import { render, staticRenderFns } from "./ModalAlunosFinalizando.vue?vue&type=template&id=cf5ca210&"
import script from "./ModalAlunosFinalizando.vue?vue&type=script&lang=js&"
export * from "./ModalAlunosFinalizando.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports